<div #labeltag id="labeltag" [ngStyle]="tagstyle">
  <div class="labeltag" [ngStyle]="tagdatastyle">{{ label }}</div>
  <div class="bodytag" [ngStyle]="tagtextstyle"><ng-content></ng-content></div>
</div>
